import styled from 'styled-components';

export const NotificationDrowpdownContainer = styled.div`
  background-color: transparent;
  border: none;
  margin: 0;
`;

export const NotificationContainer = styled.div`
  margin: 0;
  padding: 0;

  border: none;

  &::after {
    display: none;
  }
`;

export const NotificationMenu = styled.div<{ show: boolean }>`
  display: ${(props) => (props.show ? 'block' : 'none')};
  position: absolute;
  background-color: ${(props) => props.theme.color.bg.primary};
  top: 72px;
  right: 180px;
  box-shadow: 0 8px 12px rgba(52, 87, 140, 0.12); /* Shadow/4 do Figma */
  width: 360px;

  .tooltipArrow {
    position: absolute;
    top: -20px;
    left: 135px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 25px 25px 25px;
    border-color: transparent transparent white transparent;
  }
`;

export const NotificationHeader = styled.div`
  display: flex;
  height: 30px;
  justify-content: space-between;
  padding: 0 16px;
  align-items: center;
  /* background-color: red; */
  h4 {
    margin-top: 8px;
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    color: ${(props) => props.theme.color.text.primary};
  }
  border-bottom: 1px solid #f2f2f2;
`;

export const SettingsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    cursor: pointer;
  }
`;

export const NotificationBody = styled.div`
  padding: 2px 16px;
`;

export const AlertContainer = styled.div`
  &:not(:first-child) {
    border-top: 1px solid #f2f2f2;
  }

  .time {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    color: ${(props) => props.theme.color.text.primary};
    /* margin-bottom: 16px; */
    text-align: justify;
  }
  .options {
    visibility: hidden;
    position: absolute;
    right: 16px;
  }

  &:hover {
    .options {
      visibility: visible;
      background-color: #fff;
      padding: 4px 0 8px 8px;
      span {
        cursor: pointer;
        font-family: ${(props) => props.theme.font.body.family};
        font-size: ${(props) => props.theme.font.body.size.small};
        font-weight: ${(props) => props.theme.font.body.weight.regular};
        color: ${(props) => props.theme.color.text.tertiary};
        text-decoration: underline;
      }
    }
  }
`;

export const AlertHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AlertIcon = styled.div``;

export const AlertTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  h4 {
    margin-top: 8px;
    font-family: ${(props) => props.theme.font.title.family};
    font-size: ${(props) => props.theme.font.title.size.h4};
    font-weight: ${(props) => props.theme.font.title.weight.semi};
    color: ${(props) => props.theme.color.text.primary};
  }
`;

export const AlertBody = styled.div`
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  font-weight: ${(props) => props.theme.font.body.weight.regular};
  color: ${(props) => props.theme.color.text.primary};
  margin-bottom: 16px;
  text-align: justify;
`;

export const AlertEmpty = styled.div`
  padding: 20px 0;

  h4 {
    margin-top: 8px;
    font-family: ${(props) => props.theme.font.title.family};
    font-size: ${(props) => props.theme.font.title.size.h4};
    font-weight: ${(props) => props.theme.font.title.weight.semi};
    color: ${(props) => props.theme.color.text.primary};
    text-align: justify;
  }
`;
